import { Component, OnInit } from '@angular/core';
import drexApiSpec from './drex_api.json';

declare const SwaggerUIBundle: any;

@Component({
  selector: 'app-swagger-ui',
  standalone: true,
  imports: [],
  templateUrl: './swagger-ui.component.html',
  styleUrl: './swagger-ui.component.css'
})
export class SwaggerUIComponent implements OnInit {

  ngOnInit(): void {
    SwaggerUIBundle({
      dom_id: '#swagger-ui',
      layout: 'BaseLayout',
      presets: [
        SwaggerUIBundle.presets.apis,
        SwaggerUIBundle.SwaggerUIStandalonePreset
      ],
      spec: drexApiSpec as Record<string, unknown>,
      docExpansion: 'none',
      operationsSorter: 'alpha'
    });
  }
}
